import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../auth/auth-guard.service';
import {SettingComponent} from './setting.component';
import {SubscriptionSettingComponent} from './subscription-setting/subscription-setting.component';
import {UserSettingComponent} from './user-setting/user-setting.component';


const settingRoutes: Routes = [
  {
    path: 'settings', component: SettingComponent, canActivate: [AuthGuard], children: [
      {
        path: 'subscription', component: SubscriptionSettingComponent, canActivate: [AuthGuard]
      },
      {
        path: 'user', component: UserSettingComponent, canActivate: [AuthGuard]
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(settingRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class SettingRoutingModule {}
